<div class="screen-container">

  <div class="content-area d-flex flex-column align-items-center justify-content-center px-4 flex-grow-1">

    <div class="lock-icon-box mb-5">
      <i class="fas fa-lock"></i>
    </div>

    <h1 class="page-title text-center mb-2">Locked</h1>
    <p class="page-sub text-center mb-5">Enter your password to continue</p>

    <form class="lock-form w-100" [formGroup]="valForm" role="form" (submit)="submitForm($event, valForm.value)">
      <div class="input-wrapper mb-3">
        <input class="lock-input w-100" type="password" placeholder="Password" formControlName="password" />
        @if (valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)) {
          <div class="input-error mt-2"
            >
            Password is required
          </div>
        }
      </div>
      <button class="unlock-btn w-100" type="submit">
        <i class="fas fa-unlock-alt mr-2"></i>Unlock
      </button>
      <a class="forgot-link d-block text-center mt-3" [routerLink]="'/recover'">Forgot your password?</a>
    </form>

  </div>

  <div class="praticko-footer text-center py-4">
    <h2 class="footer-brand mb-1">{{ 'common.brandName' | translate }}</h2>
    <small class="footer-sub d-block">{{ 'common.developedBy' | translate }}</small>
    <small class="footer-sub d-block">{{ 'common.versionInfo' | translate }}</small>
  </div>

</div>
